import { Component, ChangeDetectionStrategy, input } from '@angular/core';



@Component({
    template: `<h1>You do not currently have access to this application.</h1>
             @if (loginError() && loginError().length > 0) {
               <h2>{{loginError()}}</h2>
             }`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class UnauthorizedComponent {
  readonly loginError = input<string>(undefined!);
}
